export const DIFFICULTIES = ['easy', 'medium', 'hard'] as const;

export type Difficulty = (typeof DIFFICULTIES)[number];

export const YEAR_PARTS = ['middle', 'end'] as const;

export type YearPart = (typeof YEAR_PARTS)[number];

export type DifficultyMix = Readonly<Record<Difficulty, number>>;

export const EMPTY_MIX: DifficultyMix = { easy: 0, medium: 0, hard: 0 };

export function mixSize(mix: DifficultyMix): number {
  return mix.easy + mix.medium + mix.hard;
}

export function countByDifficulty(
  items: Iterable<{ readonly difficulty: Difficulty }>,
): DifficultyMix {
  const counts = { easy: 0, medium: 0, hard: 0 };
  for (const item of items) {
    counts[item.difficulty] += 1;
  }
  return counts;
}

export function mixShortfall(
  available: DifficultyMix,
  required: DifficultyMix,
): DifficultyMix | null {
  const shortfall = {
    easy: Math.max(0, required.easy - available.easy),
    medium: Math.max(0, required.medium - available.medium),
    hard: Math.max(0, required.hard - available.hard),
  };
  return mixSize(shortfall) === 0 ? null : shortfall;
}
